import { BOX_STATUS } from "../../constants/boxing";

const itemMapper = (items) =>
  items?.map((item) => ({
    ...(item?.routeId && { routeId: item.routeId }),
    ...(item?.workOrderId && { workOrderId: item.workOrderId }),
    ...(item?.serialization && {
      serialization: item?.serialization?.map((label) => ({
        label,
      })),
    }),
    quantity: item.quantity,
  }));

export const getBoxFormDefaults = (s, locationId, isReturning) => ({
  status: s?.status || BOX_STATUS.READY,
  locationId: s?.locationId || locationId,
  weight: s?.weight,
  userId: s?.boxerId || (locationId == 1 ? 230 : 375),
  customerId: s?.customerId,
  ...(s?.returning && { stationId: s?.stationId }),
  routes: itemMapper(s?.routes) || [],
  workOrders: itemMapper(s?.workOrders) || [],
  returning: s?.returning ?? isReturning,
  boxes: s?.boxes,
  notes: s?.notes,
});

export const boxPayloadMapper = ({ id, formData, locationId }) => {
  const returning = formData?.returning;
  const items = formData[returning ? "routes" : "workOrders"] || [];

  const mapped = items?.map((item) => ({
    id: returning ? item.routeId : item.workOrderId,
    quantity: item.quantity,
    ...(!returning && {
      serialization: item?.serialization?.map(({ label }) => label),
    }),
  }));

  const boxes = formData.boxes?.map((b) => ({
    size: b.size,
    height: b.height,
    quantity: b.quantity,
    weight: b.weight,
  }));

  const payload = {
    ...(id && { id }),
    stationId: formData.stationId,
    customerId: formData.customerId,
    userId: formData.userId,
    status: formData.status,
    weight: formData.weight,
    notes: formData?.notes,
    returning: !!returning,
    items: mapped,
    locationId,
    boxes,
  };
  return payload;
};
